// extracted by mini-css-extract-plugin
export default {"root":"Phone_root__SejQS","button":"Phone_button__m2x1K"};